import { defineMessages } from 'react-intl';

export default defineMessages({
  placeholder_error_phone: {
    id: 'kustomer.chat.form.placeholder.error.phone.1',
    description: 'Error placeholder for incorrect phone number',
    defaultMessage: 'Please enter a valid phone number with a country code',
  },
  placeholder_error_number: {
    id: 'kustomer.chat.form.placeholder.error.number',
    description: 'Error placeholder for incorrect number',
    defaultMessage: 'Please enter a valid number...',
  },
  placeholder_error_email: {
    id: 'kustomer.chat.form.placeholder.error.email',
    description: 'Error placeholder for incorrect email number',
    defaultMessage: 'Please enter a valid email address, e.g. yourname@example.com.',
  },
  submit_error: {
    id: 'kustomer.chat.form.placeholder.error.submit',
    description: 'Error placeholder for failed submit',
    defaultMessage: "We're very sorry but there was an error with your message. Please try again later.",
  },
  thank_you_message: {
    id: 'kustomer.chat.form.thank.you.message',
    description: 'Thank you message when deflection is successfull ',
    defaultMessage: 'Thank you for contacting us!',
  },
});
